import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from '../../lib/keaConnect'
import { getOmProxyHost } from '@otavamedia/om-component-library/lib/lib/utils'
import { SubscriberIcon } from './Icons'
// import {getOptimizeValue} from '@otavamedia/om-component-library/lib/lib/utils'
// import MostReadPaidList from './MostReadPaidList'
// import {Link} from '../general/util/Links'
import WP from '@otavamedia/om-component-library/lib/lib/WP'
import auth from '@otavamedia/om-component-library/lib/kea/auth'

import './Paywall.scss'

@connect({
  props: [
    auth, [
      'loggedIn',
    ],
  ],
})
class Paywall extends Component {
  state = {
    showAdCoin: false
  }

  static propTypes = {
    titleChildren: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]),
    disableAdCoin: PropTypes.bool
  }

  static defaultProps = {
    titleChildren: [
      <h2 key="2">Haluatko lukea koko artikkelin?</h2>,
    ]
  }

  async componentDidMount () {
    /*
    const script = document.createElement('script')
    script.setAttribute('id', 'paywall-script')
    const paywallVersion = await getOptimizeValue(window.om_constants.paywallOptimize)
    script.src = paywallVersion === 1 ? '/assets/paywall2-short.js' : '/assets/paywall3.js'
    script.async = true
    const paywallRoot = document.getElementById('paywall-root')
     */
    window.paywallHost = window.om_constants.paywallHost
    window.paywallBrandId = window.om_constants.paywallBrandId
    window.offerId = window.location.host.includes(window.om_constants.paywallHost)
      ? window.om_constants.offerId
      : window.om_constants.offerIdDev
    window.paywallApiUrl = getOmProxyHost()
    const oldPWScript = document.querySelector('#paywall-script')
    if (oldPWScript) {
      document.body.removeChild(oldPWScript)
    }
    // paywallRoot.appendChild(script)

    const addScript = document.createElement('script')
    // addScript.defer = true
    addScript.setAttribute('id', 'adcoin-script')
    addScript.setAttribute('src', process.env.ADCOIN_URL || 'https://adserve.adcoin.com/display/snippet/23/128/')
    const oldScript = document.querySelector('#adcoin-script')
    if (oldScript) {
      document.body.removeChild(oldScript)
    }
    document.body.appendChild(addScript)
    this.adCoinWatcher()
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'paywallVisible' })
    }
  }

  adCoinWatcher () {
    const that = this
    const interval = window.setInterval(function () {
      // If the Adcoin ad space code <script> snippet rendered an ad, then show
      // a short intro text above the ad
      if (document.getElementById('adcoinUnlockButton') && document.getElementById('adcoinUnlockButton').style.display !== 'none') {
        window.clearInterval(interval)
        that.setState({ showAdCoin: true })
        window.dataLayer && window.dataLayer.push({
          event: 'adCoinVisible',
          adCoinVisible: true
        })
      }
    }, 1000)

    // Don't run the interval forever. Give an Adcoin ad time to load.
    window.setTimeout(function () {
      window.clearInterval(interval)
    }, 20000)
  }

  render () {
    const { showAdCoin } = this.state
    const { disableAdCoin } = this.props

    return <Fragment>
      {!disableAdCoin && <div styleName={'adcoin-block' + (showAdCoin ? ' adcoin-available' : '')}>
        {showAdCoin && <div>
          <h3 styleName="adcoin-title">Lue koko juttu ilmaiseksi!</h3>
          <p styleName="adcoin-desc">Voit lukea koko artikkelin ilmaiseksi katsomalla mainoksen</p>
        </div>}
        <div id="adcoin_unlock_button"></div>
        <div id="adcoin_ad_element"></div>
      </div>}
      <div styleName="top">
        <SubscriberIcon/>
        <a styleName="login-button" href={WP.getLoginUrl()}>
          <span>Kirjaudu</span>
        </a>
      </div>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div styleName="wrapper" onKeyDown={(e) => e.stopPropagation()}
        onTouchStart={(e) => e.stopPropagation()}
        onTouchMove={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}>

        {/* <MostReadPaidList/> */}
        <div id="paywall-root" styleName="paywall-ab">
          <div>
            <div className="paywall-order-form">
              <div className="intro"><h2>Tilaa Erä ja saat jutun heti luettavaksesi</h2>
                <input type="button" value="Katso tarjous" onClick={() => { window.location = 'https://tilaus.eralehti.fi/muurilehti?promoID=OM_maksumuuri-linkki&promoName=OM_ER&promoCreative=onlinetarjous&promoPosition=maksumuuri-ER' }}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  }
}

export default Paywall
